var _path, _g, _path2, _g2, _path3, _g3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCashflowModeller(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_40_97)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_40_97",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 27,
    y: 15,
    width: 12,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.8197 15.6605H29.5421C28.5744 15.6605 27.79 16.4449 27.79 17.4125V36.8194C27.79 37.7871 28.5744 38.5715 29.5421 38.5715H36.8197C37.7873 38.5715 38.5717 37.7871 38.5717 36.8194V17.4125C38.5717 16.4449 37.7873 15.6605 36.8197 15.6605Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_40_97)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.8197 15.6605H29.5421C28.5744 15.6605 27.79 16.4449 27.79 17.4125V36.8194C27.79 37.7871 28.5744 38.5715 29.5421 38.5715H36.8197C37.7873 38.5715 38.5717 37.7871 38.5717 36.8194V17.4125C38.5717 16.4449 37.7873 15.6605 36.8197 15.6605Z",
    stroke: "white",
    strokeWidth: 2.80239
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_40_97",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 26,
    width: 12,
    height: 13
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.86558 26.4429H2.58797C1.62035 26.4429 0.835938 27.2273 0.835938 28.1949V36.8202C0.835938 37.7878 1.62035 38.5723 2.58797 38.5723H9.86558C10.8332 38.5723 11.6176 37.7878 11.6176 36.8202V28.1949C11.6176 27.2273 10.8332 26.4429 9.86558 26.4429Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_40_97)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.86558 26.4429H2.58797C1.62035 26.4429 0.835938 27.2273 0.835938 28.1949V36.8202C0.835938 37.7878 1.62035 38.5723 2.58797 38.5723H9.86558C10.8332 38.5723 11.6176 37.7878 11.6176 36.8202V28.1949C11.6176 27.2273 10.8332 26.4429 9.86558 26.4429Z",
    stroke: "white",
    strokeWidth: 2.80239
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_40_97",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 21,
    width: 12,
    height: 18
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3412 21.0529H16.0636C15.0959 21.0529 14.3115 21.8373 14.3115 22.8049V36.8212C14.3115 37.7888 15.0959 38.5732 16.0636 38.5732H23.3412C24.3088 38.5732 25.0932 37.7888 25.0932 36.8212V22.8049C25.0932 21.8373 24.3088 21.0529 23.3412 21.0529Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_40_97)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.3412 21.0529H16.0636C15.0959 21.0529 14.3115 21.8373 14.3115 22.8049V36.8212C14.3115 37.7888 15.0959 38.5732 16.0636 38.5732H23.3412C24.3088 38.5732 25.0932 37.7888 25.0932 36.8212V22.8049C25.0932 21.8373 24.3088 21.0529 23.3412 21.0529Z",
    stroke: "white",
    strokeWidth: 2.80239
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.53223 19.0301L14.9877 8.24837L21.0524 14.3131L32.508 2.85754M32.508 10.0004V2.85754H25.0955",
    stroke: "white",
    strokeWidth: 1.40119,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_40_97"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashflowModeller);
export default __webpack_public_path__ + "static/media/CashflowModeller.18bea642d02bf7aa3d3c8e0741923798.svg";
export { ForwardRef as ReactComponent };